<template>
  <div>
    <v-row class="" align="center" align-content-sm="left">
        <v-col cols="12" md="4">
      <h3 align="start">Upload Documents List</h3>
      </v-col>
        <v-spacer></v-spacer>

       <v-col cols="12" md="6">
      <v-text-field
        v-if="currentUser.privileges.canViewUploadedDocuments"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search documents list"
        single-line
        hide-details
        align-self="center"
        class="my-2 mx-5"
      ></v-text-field>
      
       </v-col>
       <!-- <v-col cols="12" md="3" align-self="center">
      <div class="text-right">
        <v-btn rounded color="primary">
          <v-icon>mdi-account-plus</v-icon>
          Add Registration
        </v-btn>
      </div>
      </v-col> -->
    </v-row>

    <v-data-table
      :headers="headers"
      v-if="currentUser.privileges.canViewUploadedDocuments"

      :items="registrations"
      :multi-sort="false"
      :options.sync="options"
      v-model="selected"
      :items-per-page="15"
    >
      <template v-slot:item.admission_unique_id="{ item }">
        <router-link
          :to="{name: 'EditAdmissionDetails', params: {admission_id: item.id}}"
        >
          <span>{{ item.admission_unique_id || "-" }}</span>
        </router-link>
      </template> 
      <template v-slot:item.current_status="{ item }">
        <v-chip :color="item.is_terminated? 'red' : 'primary'" outlined>
          <h5>{{ item.current_status }}</h5>
        </v-chip>
      </template>
      <template v-slot:item.created_at="{item}">
        {{ moment(item.created_at).format("D MMM, YYYY") }}
      </template>
      <template v-slot:item.full_name="{item}">
        {{ item.basic_info.candidate_first_name }} {{ item.basic_info.candidate_last_name }}
      </template>
    </v-data-table>
    <div v-else>
      <h3>You do not have the sufficient permissions.</h3>


    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import moment from "moment";

export default {
  name: "RegistrationsList",
 
  data() {
    return {
      pagination: {
        totalCount: 0,
        url: endpoints.admissions + "?status=3&is_terminated=False",
      },
      search: "",
      singleSelect: false,
      selected: [],
      disabledCount: 0,
      headers: [
        {
          text: "Registration no.",
          align: "left",
          sortable: true,
          value: "admission_unique_id"
        },
        {
          text: "Date",
          align: "left",
          sortable: true,
          value: "created_at"
        },
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "full_name"
        },
        {
          text: "Documents",
          align: "left",
          sortable: false,
          value: "basic_info.uploaded_documents_count"
        },
        {
          text: "Status",
          align: "left",
          sortable: true,
          value: "current_status"
        }
      ],
      registrations:[],
      snackbar: {
        visible: false,
        text: "",
      },
      options:{},
    };
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods:{
    ...mapActions(["setLoading"]),
    moment: moment,

    selectAllToggle(props) {
      if(this.selected.length != this.applications.length - this.disabledCount) {
        this.selected = [];
        const self = this;
        props.items.forEach(item => {
          if(!item.is_terminated) {
            self.selected.push(item);
          } 
        });
      } else this.selected = [];
    },
    
    async getAllRegistrations(){
      var response;
      var url = this.pagination.url;
      if(this.search){
        url += (url.split("?")[1] ? "&" : "?") + "q=" + this.search;
      }
      response = await api.call(this.apiEssentials, url);
      if(response){
        this.registrations = response.results;
        this.pagination.totalCount = response.count;
        this.pagination.nextUrl = response.next;
      } 
    },

    enquiry_status_color(item){
      return item.is_terminated ? 'red' : 'primary'; 
    },
    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },
  },
  watch:{
    options: {
      async handler() {
        this.pagination.url =
          endpoints.admissions + "?status=3&is_terminated=False&page=" + this.options.page;
          if (this.options.sortBy.length > 0) {
          // get url var
          var params = "&order_by=";
          
          // iterate over sortBy options and add sortby and sortdesc seperated with commas
          for (var sortOption in this.options.sortBy) {
            params +=
              (this.options.sortDesc[sortOption] ? "" : "-") +
              this.options.sortBy[sortOption];
            if (sortOption != this.options.sortBy.length - 1) params += ",";
          }

          if(params.includes('full_name')){
            params = params.replace('full_name','application_details__candidate_first_name')
          }
          if (params.includes("created_at")) {
            params = params.replace("created_at", "updated_on");
          }
          if (params.includes("current_status")) {
            params = params.replace("current_status", "unlock_for_next");
          }

          this.pagination.url += params;
          // this.export_url += params;
        }
         if(this.currentUser.privileges.canViewUploadedDocuments) this.getAllRegistrations();
      },
    },
    search: {
      async handler() {
          this.options.page = 1;
          var searched = this.search;
          var self = this;
          setTimeout(function () {
              if (searched == self.search) {
                  if(this.currentUser.privileges.canViewUploadedDocuments)self.getAllRegistrations();
              }
          }, 500);
      },
    }
  },
  created(){
    const self = this;
    this.registrations.map(item => {
      if (item.is_terminated) self.disabledCount += 1
    });
    // this.getAllRegistrations(); <- already called in options watch
  }
};
</script>


<style scoped>
.data {
  text-align: start;
  vertical-align: middle;
}

.headers {
  text-align: start;
  font-weight: bolder;
  color: #0c090a;
  vertical-align: middle;
}
</style>
